export default __webpack_public_path__ + "static/media/courses-grey.8e0bbb5e.svg";